module.exports = __webpack_public_path__ + "static/media/204-Kaffee_ID_20.afa4e113.mp3";